<template>
    <div class="message-container">
        <div v-for="(displayMessage, index) in displayMessages" :key="index" :class="['message-div']"><img :src="setMessageIcon(displayMessage.type)" alt="">{{ `${displayMessage.text}` }}</div>
    </div>
</template>
<script>

// @messages: the messages array displayed on the top of page.
// e.g. [{ text: 'show the message',type: 'error', delay: 3 }]

export default {
  props: ['messages'],
  data () {
    return {
      internalId: 0,
      displayMessages: [],
      internalMessages: {},
      noticeInternal: 0
    }
  },
  watch: {
    noticeInternal () {
      const displayMessagesTemp = []
      for (const key in this.internalMessages) {
        const displayMessage = this.internalMessages[key]
        if (displayMessage) {
          displayMessagesTemp.push(displayMessage)
        }
      }
      this.displayMessages = displayMessagesTemp
    },
    messages (val, oldVal) {
      const lastMessage = val[val.length - 1]
      this.internalId++
      const id = `messageId${this.internalId}`
      const temp = this.internalMessages
      temp[id] = {
        text: lastMessage.text,
        type: lastMessage.type,
        delay: lastMessage.delay
      }
      this.$set(this.internalMessages, temp)
      this.noticeInternal++
      setTimeout(() => {
        delete this.internalMessages[id]
        this.noticeInternal++
      }, Number(lastMessage.delay) * 1000)
    }
  },
  methods: {
    setMessageIcon (type) {
      return require(`@/assets/image/questionnaire/common/${type}.png`)
    }
  }
}
</script>
<style lang="scss" scoped>
.message-container {
    width: 100%;
    display: flex;
    z-index: 109;
    flex-direction: column;
    align-items: center;
    div {
        max-width: 80%;
        margin-bottom: 10px;
        padding: 10px;
        border-radius: 3px;
        font-size: small;
        color: black;
        display: flex;
        align-items: center;
        background-color: #f5f5f5;
        box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
        img {
            margin-right: 10px;
            width: 15px;
            height: 15px;
        }
    }
}
/* 小型设备（平板电脑，768px 起） */
@media (min-width: 768px) {
    .message-div {
        font-size: medium !important;
    }
}
</style>
